import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TableConfig } from '../core/models/table-config.model';
import { Router } from '@angular/router';
import { AuditService } from '../core/services/audit.service';
import { PorsantTypePipe } from '../shared/pipes/porsant-type.pipe';
import * as moment from 'moment-jalaali';

@Component({
  selector: 'bt-rewards',
  templateUrl: './rewards.component.html',
  styleUrls: ['./rewards.component.scss']
})
export class RewardsComponent implements OnInit {
  loading = true;
  data;
  showFilter = true;
  pageNumber;
  nowDate = new Date();
  form: FormGroup;
  configTable: TableConfig = {
    row: [
      {
        columnDef: 'rowId',
        header: 'ردیف',
        cell: (row) => row.rowId,
        type: 'string',
      }, {
        columnDef: 'userName',
        header: ' نام صاحب آگهی',
        cell: (row) => row.userName,
      }, {
        columnDef: 'postId',
        header: 'شناسه آگهی',
        cell: (row) => row.postId,
        type: 'string'
      }, {
        columnDef: 'porsant',
        header: 'مبلغ پورسانت',
        cell: (row) => row.porsant,
        type: 'price'
      }, {
        columnDef: 'type',
        header: 'بابت',
        cell: (row) => new PorsantTypePipe().transform(row.type),
      }, {
        columnDef: 'description',
        header: 'توضیحات',
        cell: (row) => row.description,
        type: 'string'
      }, {
        columnDef: 'createDate',
        header: 'تاریخ ثبت',
        cell: (row) => row.createDate,
        type: 'date'
      },
    ],
    operaions: [],
    footer: [],
    paginator: {
      itemPerPage: 10,
      client: false
    }
  };
  payload = {
    startDate: '-1',
    endDate: '-1',
    pageSize: '10',
    pageNumber: '1',
  };
  constructor(
    private auditService: AuditService,
    private router: Router,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.getData();
    this.createForm();
  }
  search() {
    this.payload.startDate = this.form.value.startDate ?
      moment(new Date(this.form.value.startDate)).format('YYYY-MM-DD') : '-1';
    this.payload.endDate = this.form.value.endDate ?
      moment(new Date(this.form.value.endDate)).format('YYYY-MM-DD') : '-1';
    this.getData();
  }
  createForm() {
    this.form = this.fb.group({
      startDate: '',
      endDate: '',
    });
  }
  pageSelected(event) {
    this.payload.pageNumber = String(event);
    this.getData();
  }
  getData() {
    this.auditService.getPorsant(this.payload).subscribe(
      res => {
        this.data = res.data;
        this.pageNumber = res.pageNumber;
        this.loading = false;

      }
    );
  }

}
